
const conversations = [
  { id: 1, name: 'Sarah Kowalski', initials: 'SK', color: 'primary',  preview: 'Can you take a look at the design?', time: '4m', unread: 2,  online: true  },
  { id: 2, name: 'Michael Reyes',  initials: 'MR', color: 'blue',     preview: 'Lunch tomorrow at noon?',           time: '32m', unread: 1, online: true  },
  { id: 3, name: 'Design Team',    initials: 'DT', color: 'purple',   preview: 'Emily: Updated the timeline',        time: '1h', unread: 0,  online: false, group: true },
  { id: 4, name: 'Emily Wang',     initials: 'EW', color: 'yellow',   preview: 'Sprint retro notes posted',          time: '2h', unread: 0,  online: false },
  { id: 5, name: 'Diego Reyes',    initials: 'DR', color: 'green',    preview: 'Customer feedback summary ready',    time: 'Mon', unread: 0, online: true  },
  { id: 6, name: 'Mark Kim',       initials: 'MK', color: 'red',      preview: 'PR #248 ready for review',           time: 'Mon', unread: 0, online: false },
  { id: 7, name: 'Lina Park',      initials: 'LP', color: 'cyan',     preview: 'Campaign metrics for Q1',            time: 'Sun', unread: 0, online: false },
  { id: 8, name: 'Yuki Tanaka',    initials: 'YT', color: 'azure',    preview: 'Translation files ready',            time: 'Fri', unread: 0, online: true  }
];

const colorVar = { primary:'var(--primary)', azure:'var(--azure)', blue:'var(--blue)', purple:'var(--purple)', yellow:'var(--yellow)', red:'var(--red)', green:'var(--green)', cyan:'var(--cyan)' };

const threads = {
  1: [
    { from: 'them', text: 'Hey! Just shared the latest design exploration in Figma — can you take a look?', time: 'Today · 9:42' },
    { from: 'them', text: 'Specifically interested in your take on the dashboard density.', time: 'Today · 9:42' },
    { from: 'me',   text: 'On it — opening now.', time: 'Today · 9:48' },
    { from: 'me',   text: 'I think the stat cards are a bit dense at 768px. Want to try a 2-up layout there instead of 3?', time: 'Today · 9:51' },
    { from: 'them', text: 'Yes good call. I\'ll push an update later today.', time: 'Today · 9:53' },
    { from: 'them', text: 'Can you take a look at the design?', time: 'Today · 11:14' }
  ],
  2: [
    { from: 'them', text: 'Lunch tomorrow at noon?', time: 'Today · 10:32' }
  ],
  3: [
    { from: 'them', text: 'Emily: Updated the timeline based on the dependencies discussion', time: 'Today · 8:30' },
    { from: 'them', text: 'Sarah: Looks good — I added the design review milestones', time: 'Today · 8:45' }
  ],
  4: [
    { from: 'them', text: 'Sprint retro notes posted in Notion', time: 'Today · 7:20' }
  ],
  5: [
    { from: 'them', text: 'Compiled the customer feedback summary — top 10 feature requests', time: 'Mon · 16:00' },
    { from: 'me',   text: 'Excellent, will read tonight.', time: 'Mon · 17:12' }
  ],
  6: [{ from: 'them', text: 'PR #248 ready for review when you have a moment.', time: 'Mon · 14:00' }],
  7: [{ from: 'them', text: 'Q1 campaign metrics summary attached.', time: 'Sun · 19:30' }],
  8: [{ from: 'them', text: 'Translation files ready for the new locale.', time: 'Fri · 15:45' }]
};

let activeId = 1;

function renderRail() {
  const list = document.getElementById('chat-conversations');
  list.innerHTML = conversations.map((c) => `
    <button type="button" class="chat-conversation${c.id === activeId ? ' active' : ''}" data-id="${c.id}">
      <span class="av" style="background:${colorVar[c.color]}">${c.initials}${c.online ? '<span class="online"></span>' : ''}</span>
      <span class="info">
        <span class="row"><span class="name">${c.name}${c.group ? ' <small>(group)</small>' : ''}</span><span class="time">${c.time}</span></span>
        <span class="preview-row"><span class="preview">${c.preview}</span>${c.unread ? `<span class="unread">${c.unread}</span>` : ''}</span>
      </span>
    </button>
  `).join('');
}

function renderThread() {
  const conv = conversations.find((c) => c.id === activeId);
  if (!conv) return;
  document.getElementById('thread-name').textContent = conv.name;
  const av = document.getElementById('thread-avatar');
  av.textContent = conv.initials;
  av.style.background = colorVar[conv.color];
  const presenceText = conv.online ? 'Online · last active 2m ago' : 'Offline';
  document.querySelector('.chat-thread-head .presence').innerHTML = `<span class="dot${conv.online ? '' : ' off'}"></span> ${presenceText}`;
  const msgs = threads[activeId] || [];
  const messagesEl = document.getElementById('chat-messages');
  messagesEl.innerHTML = msgs.map((m) => `
    <div class="chat-bubble ${m.from === 'me' ? 'mine' : 'theirs'}">
      <div class="bubble">${m.text}</div>
      <div class="meta">${m.time}</div>
    </div>
  `).join('');
  messagesEl.scrollTop = messagesEl.scrollHeight;
}

renderRail();
renderThread();

document.getElementById('chat-conversations').addEventListener('click', (e) => {
  const btn = e.target.closest('.chat-conversation');
  if (!btn) return;
  activeId = parseInt(btn.dataset.id, 10);
  // Mark read
  const conv = conversations.find((c) => c.id === activeId);
  if (conv) conv.unread = 0;
  renderRail();
  renderThread();
});

document.getElementById('chat-composer').addEventListener('submit', (e) => {
  e.preventDefault();
  e.stopPropagation();
  const input = document.getElementById('chat-input');
  const text = input.value.trim();
  if (!text) return;
  if (!threads[activeId]) threads[activeId] = [];
  const now = new Date();
  const time = `Today · ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
  threads[activeId].push({ from: 'me', text, time });
  input.value = '';
  renderThread();
  // Fake reply after 1.5s
  setTimeout(() => {
    if (activeId !== activeId) return;
    threads[activeId].push({ from: 'them', text: 'Thanks — got it 👍', time });
    renderThread();
  }, 1400);
});
